import { render } from "./OwnerCardTimeRecord.vue?vue&type=template&id=69c22f48&bindings={\"label\":\"props\",\"recentData\":\"props\",\"seasonData\":\"props\",\"allTimeData\":\"props\"}"
import script from "./OwnerCardTimeRecord.vue?vue&type=script&lang=ts"
export * from "./OwnerCardTimeRecord.vue?vue&type=script&lang=ts"
script.render = render

export default script